import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { useRegion } from "@/context/RegionContext";
import { useLanguage } from "@/context/LanguageContext";

export function ArticleList({ type, region: forcedRegion, title, label, subtitle, image, filterCategories = true }) {
  const { region: ctxRegion } = useRegion();
  const { lang } = useLanguage();
  const region = forcedRegion || ctxRegion;
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    const q = new URLSearchParams();
    if (type) q.set("type", type);
    if (region) q.set("region", region);
    q.set("lang", lang);
    q.set("limit", "60");
    client.get(`/articles?${q.toString()}`).then((r) => setArticles(r.data)).catch(() => {});
  }, [type, region, lang]);

  const cats = ["All", ...Array.from(new Set(articles.map((a) => a.category)))];
  const shown = cat === "All" ? articles : articles.filter((a) => a.category === cat);
  const feature = shown[0];
  const rest = shown.slice(1);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12">
      {image && (
        <div className="relative rounded-3xl overflow-hidden grain mb-10 h-52 sm:h-64">
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/70 to-transparent" />
          <div className="relative h-full flex flex-col justify-center px-8 sm:px-12">
            <p className="font-mono-cl text-[11px] tracking-[0.28em] text-[#ccff00] uppercase mb-2">{label}</p>
            <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight max-w-2xl leading-tight">{title}</h1>
            {subtitle && <p className="text-zinc-300 mt-3 max-w-xl">{subtitle}</p>}
          </div>
        </div>
      )}
      {!image && (
        <div className="mb-8">
          <p className="font-mono-cl text-[11px] tracking-[0.28em] text-[#ccff00] uppercase mb-2">{label}</p>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">{title}</h1>
          {subtitle && <p className="text-zinc-400 mt-3 max-w-2xl">{subtitle}</p>}
        </div>
      )}

      {filterCategories && cats.length > 1 && (
        <div className="flex flex-wrap gap-2 mb-8">
          {cats.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setCat(c)}
              className={`px-4 py-1.5 rounded-full text-xs font-mono-cl tracking-[0.1em] uppercase transition-colors ${
                cat === c ? "bg-[#ccff00] text-black font-bold" : "border border-white/10 text-zinc-400 hover:text-white hover:border-white/30"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      )}

      {shown.length === 0 ? (
        <p className="text-zinc-500 py-20 text-center">No stories in this view yet.</p>
      ) : (
        <>
          {feature && (
            <div className="mb-8">
              <ArticleCard a={feature} variant="feature" />
            </div>
          )}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((a) => <ArticleCard key={a.slug} a={a} />)}
          </div>
        </>
      )}
    </div>
  );
}
